import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UEmojiComponent } from './u-emoji-item/u-emoji-item.component';

@NgModule({
  declarations: [UEmojiComponent],
  imports: [CommonModule],
  exports: [UEmojiComponent],
})
export class UEmojiModule {}
